//jsxhook

import {
  ArtDirectedImage,
  Column,
  FontWeight,
  ImageVariants,
  ImgixAspectRatio,
  ImgixImage,
  Label2,
  radii
} from "@sixty-six-north/ui-system"
import { Box, Flex, Grid } from "theme-ui"

interface SmallProductCardProps {
  firstRowTitle: string
  firstRowDescription: string
  secondRowTitle: string
  secondRowDescription: string
  thirdRowTitle?: string
  thirdRowDescription?: string
  productImageUrl: string
  productImageTitle?: string
}

export const SmallProductCard: React.FC<SmallProductCardProps> = ({
  ...props
}) => {
  const {
    firstRowTitle,
    firstRowDescription,
    secondRowTitle,
    secondRowDescription,
    thirdRowTitle,
    thirdRowDescription,
    productImageUrl,
    productImageTitle
  } = props
  return (
    <Grid
      sx={{
        border: "1px solid",
        borderColor: "grey.3",
        borderRadius: radii.clickable,
        p: 16
      }}
      gap={16}
      columns={[2, "1fr 4fr"]}
    >
      <Box
        sx={{
          alignSelf: "center",
          backgroundColor: "grey.4",
          variant: `images.${ImageVariants.ratio_1x1}`
        }}
      >
        <ArtDirectedImage
          imageNode={
            <ImgixImage
              imageUrl={productImageUrl}
              imageAlt={productImageTitle || ""}
              aspectRatio={ImgixAspectRatio.ar1x1}
            />
          }
          imageAlt={productImageTitle || ""}
        />
      </Box>

      <Flex sx={{ flexDirection: "column" }}>
        <Flex sx={{ flexDirection: "column", marginBottom: 24 }}>
          <Label2 sx={{ color: "black.1", fontWeight: FontWeight.textBold }}>
            {firstRowTitle}
          </Label2>
          <Label2 sx={{ color: "grey.1", mt: 4 }}>{firstRowDescription}</Label2>
        </Flex>
        <Grid columns={[1, 1, "2fr 3fr 1fr"]} gap={[12, 12]}>
          <Column>
            <Label2 sx={{ color: "black.1", fontWeight: FontWeight.textBold }}>
              {secondRowTitle}
            </Label2>
            <Label2 sx={{ color: "grey.1" }}>{secondRowDescription}</Label2>
          </Column>
          {thirdRowTitle && (
            <Column>
              <Label2
                sx={{ color: "black.1", fontWeight: FontWeight.textBold }}
              >
                {thirdRowTitle}
              </Label2>
              <Label2 sx={{ color: "grey.1" }}>{thirdRowDescription}</Label2>
            </Column>
          )}
        </Grid>
      </Flex>
    </Grid>
  )
}
